import GeneralApiService from "./generalApiService";
import * as constants from "@/common/constants";

class SecureApiService extends GeneralApiService {
  /**
   * @param {Object} payload
   * @param {String} payload.email
   * @param {String} payload.password
   * @param {Boolean} payload.remember
   */
  login({ email, password, remember }) {
    return this.publicPostRequest(
      this.publicIdentityUrl + constants.API_LOGIN,
      {
        email: email.toLowerCase(),
        password,
        remember_me: remember
      }
    ).then(response => {
      if (
        response.body &&
        response.body.access_token &&
        response.body.access_token !== ""
      ) {
        this.axios.defaults.headers.common["Authorization"] =
          response.body.access_token;
        return response.body;
      } else {
        throw Error(constants.ERROR_BAD_SERVER);
      }
    });
  }

  /**
   *
   */
  logout() {
    return this.privateRequest(
      "POST",
      this.apiIdentityUrl + constants.API_LOGOUT,
      {}
    ).then(() => {
      delete this.axios.defaults.headers.common["Authorization"];
      return true;
    });
  }

  /**
   *
   */
  getProfile() {
    return this.privateRequest(
      "GET",
      this.apiIdentityUrl + constants.API_GET_PROFILE,
      {}
    )
      .then(response => {
        return response.body;
      })
      .catch(err => {
        throw err;
      });
  }

  /**
   * @param {Object} payload
   */
  postPasswordRestoreLink(payload) {
    return this.publicPostRequest(
      this.publicIdentityUrl + constants.API_RESTORE_PASSWORD,
      payload
    ).then(response => {
      if (response.code && (response.code === 200 || response.code === 201)) {
        return response.body;
      } else {
        throw Error(constants.ERROR_BAD_SERVER);
      }
    });
  }

  /**
   * @param {Object} payload
   */
  postPasswordRestoreReset(payload) {
    return this.publicPostRequest(
      this.publicIdentityUrl + constants.API_RESTORE_RESET,
      payload
    ).then(response => {
      if (response.code && (response.code === 200 || response.code === 201)) {
        return response.body;
      } else {
        throw Error(constants.ERROR_BAD_SERVER);
      }
    });
  }
}

export default SecureApiService;
